import React from 'react';
import numeral from 'numeral';
import style from 'assets/jss/material-dashboard-pro-react/components/fbbPlanDetailStyle';
import { makeStyles } from '@material-ui/core';
import { HeadingSBold, HeadingLBold, HeadingM, HeadingMBold, BodyM } from 'components/Typography/Typography';
import { dynamicTranslate, translate } from 'components/Translation';
import Button from 'components/CustomButtons/Button';
import { BorderColorSharp, PhoneInTalkOutlined } from '@material-ui/icons';
import ConditionalRender from 'components/ConditionalRender/ConditionalRender';
import { calculateExpiryDate } from 'utils/date/getExpiryDate';
import { useSelector } from 'react-redux';
import { getCommonLabels, getFiberProLabels } from 'redux/modules/dynamicLabels/selectors';
import { formatPrice } from 'utils/price';


// @ts-ignore
const useStyle = makeStyles(style);

interface IPlanDetailProps {
    subtitle: string;
    contract: string;
    planDetail: types.services.fixed.IPlan;
    description: string;
    onEdit?: () => void;
    additionalServices: types.services.fixed.IAdditionalService[];
}

const PlanDetail = (props: IPlanDetailProps) => {
    const { planDetail } = props;
    const classes = useStyle();
	const fiberProLabels = useSelector(getFiberProLabels);
	const commonLabels = useSelector(getCommonLabels);
    const getDescription = () => {
        const regex = /\((.*?)\)/;
        const desc = props.description.match(regex);
        return desc && desc.length > 1 ? desc[1] : '';
    }
    return (<>
        <div className={classes.planDetail}>
            <div className={classes.titleSection}>
                <div >
                    <span className={classes.title}><HeadingLBold color='enterprise' inline>{props.planDetail.name}</HeadingLBold></span>
                    <span className={classes.subTitle}><HeadingSBold color='enterprise' inline >{` ` + props.subtitle}</HeadingSBold></span>
                </div>
                <div className=''>
                    <ConditionalRender
                        show={!!props.onEdit}
                        onTrue={() => (
                            <Button color="tertiary-light" justIcon onClick={() => props.onEdit!()}>
                                <BorderColorSharp />
                            </Button>
                        )}
                        onFalse={() => (
                            <HeadingM inline>{dynamicTranslate(commonLabels.price, numeral(planDetail.fee).format('0.00'))}</HeadingM>
                        )}
                    />
                </div>
            </div>
            <div className={classes.flexAndJustifyContexnt}>
                <div className={classes.contract}><HeadingM inline>{props.contract}</HeadingM></div>
                <div className={classes.validity}>{calculateExpiryDate(+(planDetail?.contract ?? ''))}</div>
            </div>
            {/* <div className={classes.description}>
                <PhoneInTalkOutlined className={classes.phoneIcon} />
                <BodyM customClassName={classes.descriptionText}>{`  ` + getDescription()}</BodyM>
            </div> */}

            {props.additionalServices?.length > 0 && <>
                <ConditionalRender
                    show={!!props.onEdit}
                    onTrue={() => (
                        <hr className={classes.horizontalLine} />
                    )}
                    onFalse={() => (
                        <div className={classes.addOnServices}>
                            <BodyM>{fiberProLabels.addonServices}</BodyM>
                        </div>
                    )}
                />
                {props.additionalServices.map((addOn, index) => {
                    return <div className={classes.flexAndJustifyContexnt} key={index}>
                        <HeadingM inline>{addOn.name}</HeadingM>
                    </div>
                })}
            </>
            }
        </div>
    </>
    );
};

export default PlanDetail;
